/*
 * ICOFFEE "Build Your Own Bundle" (snippets/ic-bundle-builder.liquid, opened from snippets/ic-bundle-card.liquid).
 * Shoppers pick coffees by type, variant and size. The coffees go into the cart as ordinary lines, and the saving is
 * Shopify's own quantity discount (admin > Discounts), so the cart and both checkouts charge it by themselves.
 * The bundle sizes and percentages shown here come from Theme settings > ICOFFEE bundles and only preview that discount.
 */
(function () {
  'use strict';

  var dialog = document.getElementById('IcBundle');
  var cfgEl = document.getElementById('IcBundleConfig');
  if (!dialog || !cfgEl || dialog.icBound) return;
  dialog.icBound = true;

  var cfg = JSON.parse(cfgEl.textContent);
  var tiers = cfg.tiers.filter(function (tier) { return tier.qty > 0 && tier.percent > 0; }).sort(function (a, b) { return a.qty - b.qty; });
  if (!tiers.length) return;

  var MAX_ROWS = 12;
  var MAX_QTY = 20;

  // translations arrive HTML-escaped ("You&#39;re"); most of them are set as plain text here
  var decoder = document.createElement('textarea');
  function decode(value) {
    if (typeof value !== 'string') return value;
    decoder.innerHTML = value;
    return decoder.value;
  }
  var t = {};
  Object.keys(cfg.strings).forEach(function (key) {
    var value = cfg.strings[key];
    if (value && typeof value === 'object') {
      t[key] = {};
      Object.keys(value).forEach(function (k) { t[key][k] = decode(value[k]); });
    } else {
      // the two counters carry their own <b> markup
      t[key] = key === 'count' || key === 'count_over' ? value : decode(value);
    }
  });
  var moneyFormat = decode(cfg.money);

  var rowsEl = dialog.querySelector('[data-ic-bb-rows]');
  var listEl = dialog.querySelector('[data-ic-bb-list]');
  var rowTemplate = dialog.querySelector('[data-ic-bb-row-template]');
  var itemTemplate = dialog.querySelector('[data-ic-bb-item-template]');
  var addRowBtn = dialog.querySelector('[data-ic-bb-add-row]');
  var countEl = dialog.querySelector('[data-ic-bb-count]');
  var emptyEl = dialog.querySelector('[data-ic-bb-empty]');
  var tipTitle = dialog.querySelector('[data-ic-bb-tip-title]');
  var tipText = dialog.querySelector('[data-ic-bb-tip-text]');
  var originalEl = dialog.querySelector('[data-ic-bb-original]');
  var discountRow = dialog.querySelector('[data-ic-bb-discount-row]');
  var discountLabel = dialog.querySelector('[data-ic-bb-discount-label]');
  var discountEl = dialog.querySelector('[data-ic-bb-discount]');
  var totalEl = dialog.querySelector('[data-ic-bb-total]');
  var errorEl = dialog.querySelector('[data-ic-bb-error]');
  var submit = dialog.querySelector('[data-ic-bb-submit]');

  /* ---------- the coffees to pick from: type -> variants -> sizes ---------- */

  // the store names a coffee "<type> <variant>" ("Turkish Coffee, Dark & Plain"), so the variant is what follows the type
  var TYPE_WORDS = {
    american: /^(american coffee|americano coffee|americano|قهوة [أا]مريكي[ةه]?|القهوة ال[أا]مريكية)/i,
    turkish: /^(turkish coffee|قهوة تركي[ةه]?|القهوة التركية)/i,
    french: /^(french coffee|قهوة فرنسي[ةه]?|القهوة الفرنسية)/i,
    espresso: /^(espresso coffee|espresso|قهوة [إا]سبريسو|[إا]سبريسو)/i,
    arabic: /^(arabi(?:c|an) coffee|قهوة عربي[ةه]?|القهوة العربية)/i,
  };

  function variantName(product) {
    var rest = product.name.replace(TYPE_WORDS[product.line] || /^$/, '').replace(/^[\s,،:–-]+/, '').trim();
    // a type with a single coffee has nothing after its name: call it by its roast
    if (!rest) return (product.roast && t.roasts[product.roast]) || t.classic;
    return rest.charAt(0).toUpperCase() + rest.slice(1);
  }

  var byLine = {};
  var lines = [];
  cfg.lines.forEach(function (line) { byLine[line.key] = { key: line.key, title: decode(line.title), can: line.can, variants: [] }; });
  cfg.products.forEach(function (product) {
    var line = byLine[product.line];
    if (!line) return;
    var name = variantName(product);
    var variant = line.variants.filter(function (v) { return v.name === name; })[0];
    if (!variant) line.variants.push((variant = { name: name, sizes: [] }));
    product.variants.forEach(function (v) {
      variant.sizes.push({
        id: String(v.id),
        label: v.size || (product.weight ? t.grams.replace('[size]', product.weight) : t.one_size),
        // the coffee's own can, or its tin for the 125g size
        art: (product.tin && /125/.test(v.size) ? product.tin : product.art) || line.can,
        price: v.price,
        available: v.available,
        max: v.max > 0 ? Math.min(v.max, MAX_QTY) : MAX_QTY,
      });
    });
  });
  cfg.lines.forEach(function (line) { if (byLine[line.key].variants.length) lines.push(byLine[line.key]); });
  if (!lines.length) return;

  var inStock = function (variant) { return variant.sizes.some(function (size) { return size.available; }); };
  var firstSize = function (variant) { return variant.sizes.filter(function (size) { return size.available; })[0] || variant.sizes[0]; };

  /* ---------- state ---------- */

  var uid = 0;
  var state = { goal: tiers[0].qty, rows: [] };

  function blank() { return { uid: ++uid, line: '', variant: -1, size: '', qty: 1, el: null }; }
  function variantOf(row) { return byLine[row.line] ? byLine[row.line].variants[row.variant] || null : null; }
  function sizeOf(row) {
    var variant = variantOf(row);
    return (variant && variant.sizes.filter(function (size) { return size.id === row.size; })[0]) || null;
  }
  function filled(row) {
    var size = sizeOf(row);
    return !!(size && size.available);
  }
  function count() { return state.rows.reduce(function (n, row) { return n + (filled(row) ? row.qty : 0); }, 0); }
  function empties() { return state.rows.filter(function (row) { return !filled(row); }).length; }
  function tierFor(n) { return tiers.filter(function (tier) { return n >= tier.qty; }).pop() || null; }
  function nextTier(n) { return tiers.filter(function (tier) { return tier.qty > n; })[0] || null; }
  function rowOf(el) {
    var holder = el.closest('[data-uid]');
    return holder ? state.rows.filter(function (row) { return String(row.uid) === holder.dataset.uid; })[0] || null : null;
  }

  // keep an open slot for every coffee the chosen bundle still needs
  function pad() {
    while (state.rows.length < MAX_ROWS && (count() + empties() < state.goal || !state.rows.length)) state.rows.push(blank());
  }

  // more coffees than the chosen bundle: aim for the next size up
  function settle() {
    var n = count();
    if (n > state.goal) state.goal = (tiers.filter(function (tier) { return tier.qty >= n; })[0] || tiers[tiers.length - 1]).qty;
    pad();
  }

  function setGoal(qty) {
    state.goal = qty;
    // a smaller bundle: first bring doubled coffees back to one each, then take coffees off the end until it fits,
    // and drop the slots it no longer needs
    for (var k = state.rows.length - 1; k >= 0 && count() > qty; k--) {
      if (filled(state.rows[k])) state.rows[k].qty = Math.max(1, state.rows[k].qty - (count() - qty));
    }
    for (var i = state.rows.length - 1; i >= 0 && count() > qty; i--) {
      if (filled(state.rows[i])) state.rows.splice(i, 1);
    }
    for (var j = state.rows.length - 1; j >= 0; j--) {
      if (!filled(state.rows[j]) && count() + empties() > qty) state.rows.splice(j, 1);
    }
    pad();
  }

  function pick(row, lineKey) {
    var line = byLine[lineKey];
    row.line = line ? lineKey : '';
    row.variant = -1;
    row.size = '';
    if (!line) return;
    line.variants.some(function (variant, index) {
      if (!inStock(variant)) return false;
      row.variant = index;
      return true;
    });
    if (row.variant < 0) row.variant = 0;
    row.size = firstSize(line.variants[row.variant]).id;
    clamp(row);
  }

  function clamp(row) {
    var size = sizeOf(row);
    row.qty = Math.max(1, Math.min(row.qty, size ? size.max : MAX_QTY));
  }

  /* ---------- rendering ---------- */

  function money(cents) {
    return moneyFormat.replace('[amount]', (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  function option(value, label, selected, disabled) {
    var el = document.createElement('option');
    el.value = value;
    el.textContent = label;
    el.selected = !!selected;
    el.disabled = !!disabled;
    return el;
  }

  // rebuild a <select> only when its options or its value changed, so the one in use keeps its focus and state
  function fill(select, options, disabled) {
    var signature = options.map(function (o) { return [o.value, o.label, o.selected ? 1 : 0, o.disabled ? 1 : 0].join('|'); }).join('~');
    select.disabled = disabled;
    if (select.dataset.signature === signature) return;
    select.dataset.signature = signature;
    select.textContent = '';
    options.forEach(function (o) { select.appendChild(option(o.value, o.label, o.selected, o.disabled)); });
  }

  function stepper(holder, row, key) {
    var size = sizeOf(row);
    var on = filled(row);
    var minus = holder.querySelector('[data-ic-bb-step="-1"]');
    var plus = holder.querySelector('[data-ic-bb-step="1"]');
    holder.querySelector('[data-ic-bb-qty]').textContent = row.qty;
    minus.disabled = !on || row.qty <= 1;
    plus.disabled = !on || row.qty >= size.max;
    minus.dataset.bbFocus = key + '-dec-' + row.uid;
    plus.dataset.bbFocus = key + '-inc-' + row.uid;
    holder.querySelector('[data-ic-bb-remove]').dataset.bbFocus = key + '-rm-' + row.uid;
  }

  function renderRow(row, index) {
    var fresh = !row.el;
    if (fresh) {
      row.el = rowTemplate.content.firstElementChild.cloneNode(true);
      row.el.dataset.uid = row.uid;
    }
    var el = row.el;
    var line = byLine[row.line] || null;
    var variant = variantOf(row);

    el.setAttribute('aria-label', t.row.replace('[n]', index + 1));
    el.querySelector('[data-ic-bb-num]').textContent = index + 1;
    el.querySelector('[data-ic-bb-qty-group]').setAttribute('aria-label', t.row.replace('[n]', index + 1));

    var thumb = el.querySelector('[data-ic-bb-thumb]');
    var img = thumb.querySelector('img');
    var art = line && ((sizeOf(row) || {}).art || line.can);
    thumb.classList.toggle('is-empty', !line);
    img.hidden = !line;
    if (line && img.getAttribute('src') !== art) img.src = art;

    var types = lines.map(function (l) {
      var none = !l.variants.some(inStock);
      return { value: l.key, label: l.title + (none ? ' · ' + t.sold_out : ''), selected: l.key === row.line, disabled: none };
    });
    if (!line) types.unshift({ value: '', label: t.choose_type, selected: true });
    fill(el.querySelector('[data-ic-bb-type]'), types, false);

    fill(el.querySelector('[data-ic-bb-variant]'), line ? line.variants.map(function (v, i) {
      var none = !inStock(v);
      return { value: String(i), label: v.name + (none ? ' · ' + t.sold_out : ''), selected: i === row.variant, disabled: none };
    }) : [{ value: '', label: '—', selected: true }], !line);

    fill(el.querySelector('[data-ic-bb-size]'), variant ? variant.sizes.map(function (size) {
      return { value: size.id, label: size.label + (size.available ? '' : ' · ' + t.sold_out), selected: size.id === row.size, disabled: !size.available };
    }) : [{ value: '', label: '—', selected: true }], !variant);

    stepper(el, row, 'row');
    // an open slot the bundle still needs can't be thrown away
    el.querySelector('[data-ic-bb-remove]').disabled = !line && count() + empties() <= state.goal;

    if (rowsEl.children[index] !== el) rowsEl.insertBefore(el, rowsEl.children[index] || null);
    if (fresh && dialog.open) el.classList.add('is-enter');
  }

  function renderItem(row) {
    var el = itemTemplate.content.firstElementChild.cloneNode(true);
    var line = byLine[row.line];
    var size = sizeOf(row);
    el.dataset.uid = row.uid;
    el.querySelector('img').src = size.art || line.can;
    el.querySelector('[data-ic-bb-item-title]').textContent = line.title;
    el.querySelector('[data-ic-bb-item-meta]').textContent = variantOf(row).name + ' · ' + size.label;
    el.querySelector('[data-ic-bb-qty-group]').setAttribute('aria-label', line.title + ', ' + variantOf(row).name);
    stepper(el, row, 'item');
    return el;
  }

  function render() {
    var active = document.activeElement;
    var focusKey = active && dialog.contains(active) ? active.dataset.bbFocus : null;

    Array.prototype.slice.call(rowsEl.children).forEach(function (el) {
      if (!state.rows.some(function (row) { return row.el === el; })) el.remove();
    });
    state.rows.forEach(renderRow);
    addRowBtn.hidden = state.rows.length >= MAX_ROWS;

    var chosen = state.rows.filter(filled);
    listEl.textContent = '';
    chosen.forEach(function (row) { listEl.appendChild(renderItem(row)); });
    emptyEl.hidden = chosen.length > 0;

    var n = count();
    var tier = tierFor(n);
    var next = nextTier(n);
    var original = 0;
    var discount = 0;
    chosen.forEach(function (row) {
      var lineTotal = sizeOf(row).price * row.qty;
      original += lineTotal;
      // Shopify takes the percentage off each line
      if (tier) discount += Math.round((lineTotal * tier.percent) / 100);
    });

    countEl.innerHTML = (n > state.goal ? t.count_over : t.count).replace('[n]', n).replace('[goal]', state.goal);
    dialog.querySelectorAll('input[name="IcBundleTier"]').forEach(function (radio) { radio.checked = Number(radio.value) === state.goal; });

    if (next) {
      var missing = next.qty - n;
      var words = missing === 1 ? t.tip_need_one : missing === 2 ? t.tip_need_two : t.tip_need_many;
      tipTitle.textContent = tier ? t.tip_more : t.tip_start;
      tipText.textContent = words.replace('[n]', missing).replace('[percent]', next.percent);
    } else {
      tipTitle.textContent = t.tip_best;
      tipText.textContent = t.tip_best_text.replace('[percent]', tier.percent);
    }

    originalEl.textContent = money(original);
    discountRow.hidden = !discount;
    if (tier) discountLabel.textContent = t.discount.replace('[percent]', tier.percent);
    discountEl.textContent = '− ' + money(discount);
    totalEl.textContent = money(original - discount);
    submit.disabled = !tier;

    // the summary is rebuilt on every change, and a − that reached 1 switches off: keep the keyboard where it was
    var current = document.activeElement;
    if (focusKey && (!current || current === document.body || !dialog.contains(current) || current.disabled)) {
      var target = dialog.querySelector('[data-bb-focus="' + focusKey + '"]');
      if (target && target.disabled) target = target.parentElement.querySelector('[data-ic-bb-step]:not(:disabled)');
      if (!target) target = addRowBtn.hidden ? dialog.querySelector('[data-ic-bb-close]') : addRowBtn;
      target.focus({ preventScroll: true });
    }
  }

  /* ---------- opening and closing ---------- */

  function open(goal) {
    goal = tiers.some(function (tier) { return tier.qty === goal; }) ? goal : 0;
    // a bundle already under way is never cut down by reopening
    if (goal && (count() === 0 || goal > state.goal)) setGoal(goal);
    pad();
    errorEl.hidden = true;
    render();
    if (dialog.open) return;
    document.documentElement.classList.add('ic-bb-lock');
    dialog.showModal();
  }

  dialog.addEventListener('close', function () { document.documentElement.classList.remove('ic-bb-lock'); });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ic-bundle-open]');
    if (!opener) return;
    e.preventDefault();
    var card = opener.closest('[data-ic-bcard]');
    var checked = card && card.querySelector('input[type="radio"]:checked');
    open(Number(checked ? checked.value : opener.dataset.icBundleOpen) || 0);
  });

  // the shop card prices the bundle size picked on it
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-ic-bcard] input[type="radio"]')) return;
    var from = e.target.closest('[data-ic-bcard]').querySelector('[data-ic-bcard-from]');
    if (from) from.textContent = e.target.dataset.from;
  });

  /* ---------- inside the dialog ---------- */

  dialog.addEventListener('change', function (e) {
    var target = e.target;
    if (target.name === 'IcBundleTier') {
      setGoal(Number(target.value));
      return render();
    }
    var row = rowOf(target);
    if (!row) return;
    if (target.matches('[data-ic-bb-type]')) {
      pick(row, target.value);
    } else if (target.matches('[data-ic-bb-variant]')) {
      row.variant = Number(target.value);
      row.size = firstSize(variantOf(row)).id;
      clamp(row);
    } else if (target.matches('[data-ic-bb-size]')) {
      row.size = target.value;
      clamp(row);
    }
    settle();
    render();
  });

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog || e.target.closest('[data-ic-bb-close]')) return dialog.close();

    var step = e.target.closest('[data-ic-bb-step]');
    var remove = e.target.closest('[data-ic-bb-remove]');
    if (step || remove) {
      var row = rowOf(step || remove);
      if (!row) return;
      if (step) {
        row.qty += Number(step.dataset.icBbStep);
        clamp(row);
      } else {
        state.rows.splice(state.rows.indexOf(row), 1);
      }
      settle();
      return render();
    }

    if (e.target.closest('[data-ic-bb-add-row]') && state.rows.length < MAX_ROWS) {
      var added = blank();
      state.rows.push(added);
      render();
      added.el.querySelector('[data-ic-bb-type]').focus();
    }
  });

  submit.addEventListener('click', function () {
    if (submit.getAttribute('aria-busy') === 'true') return;
    var quantities = {};
    state.rows.filter(filled).forEach(function (row) { quantities[row.size] = (quantities[row.size] || 0) + row.qty; });
    // one id for the whole bundle: the cart shows lines that share it as a single bundle (snippets/ic-cart-bundle)
    var bundle = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var items = Object.keys(quantities).map(function (id) { return { id: id, quantity: quantities[id], properties: { _bundle: bundle } }; });
    if (!items.length) return;

    submit.setAttribute('aria-busy', 'true');
    errorEl.hidden = true;
    var done = function () {
      state.rows.forEach(function (row) { if (row.el) row.el.remove(); });
      state = { goal: tiers[0].qty, rows: [] };
      dialog.close();
    };
    var adding;
    if (window.IcCart) {
      // the cart drawer opens once this dialog is out of the way
      adding = window.IcCart.add(items, { open: false }).then(function () {
        done();
        window.IcCart.open();
      });
    } else {
      adding = fetch(cfg.routes.add, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var err = new Error('cart_error');
            err.data = data;
            throw err;
          }
          location.href = cfg.routes.cart;
        });
      });
    }
    adding
      .catch(function (err) {
        var message = err && err.data && (err.data.description || err.data.message);
        errorEl.textContent = typeof message === 'string' && message ? message : t.error;
        errorEl.hidden = false;
      })
      .finally(function () { submit.removeAttribute('aria-busy'); });
  });

  if (location.hash === '#build-bundle') open(0);
})();
